// @flow

import { css } from 'styled-components';
import type { ACFColumnColor } from '../../types/acf/column';
import type { Theme } from '../../types';

export const getColor = (
  colorName: ?ACFColumnColor,
  theme: Theme,
  defaultColor?: string,
): string => {
  switch (colorName) {
    case 'light':
      return theme.background.light;
    case 'dark':
      return theme.background.dark;
    case 'primary':
      return theme.background.primary;
    case 'secondary':
      return theme.background.secondary;
    case 'tertiary':
      return theme.background.tertiary;
    default:
      return defaultColor || theme.background.default;
  }
};

export const getBackgroundColor = (
  colorName: ?ACFColumnColor,
  theme: Theme,
  defaultColor?: string,
) => {
  const color = getColor(colorName, theme, defaultColor);
  return css`
    background-color: ${color};
  `;
};

export default null;
